export interface KeyboardViewport {
	height: number;
	offsetTop: number;
}

interface FerniePanelSizingArgs {
	keyboardViewport: KeyboardViewport | null;
	poppedOut: boolean;
}

interface FerniePanelSizing {
	height: string;
	top: number | string;
}

const resolveFerniePanelSizing = ({ keyboardViewport, poppedOut }: FerniePanelSizingArgs): FerniePanelSizing => {
	if (poppedOut) {
		return { height: "100%", top: "auto" };
	}

	if (!keyboardViewport) {
		return { height: "100%", top: 0 };
	}

	return { height: `${keyboardViewport.height}px`, top: `${keyboardViewport.offsetTop}px` };
};

export default resolveFerniePanelSizing;
